import { render, staticRenderFns } from "./AmountSelector.vue?vue&type=template&id=72e9dc9b&scoped=true"
import script from "./AmountSelector.vue?vue&type=script&lang=js"
export * from "./AmountSelector.vue?vue&type=script&lang=js"
import style0 from "./AmountSelector.vue?vue&type=style&index=0&id=72e9dc9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e9dc9b",
  null
  
)

export default component.exports